import { Settings, SettingsService } from '../shared/SettingsService';

export class BasketChangedEmitter {
    private static readonly AMOUNT_SELECTOR = '.or_js_miniBasketAmount';

    constructor(private readonly settings?: SettingsService) {}

    emit(): void {
        if (!this.settings?.isEnabled(Settings.FT1_35301_NEXUS_BASKET_CHANGED)) {
            return;
        }

        const amount = this.readAmount();
        if (amount !== undefined) {
            window.otto?.order?.basket?.changed?.emit({ amount }, { retain: true });
        }
    }

    private readAmount(): number | undefined {
        const raw = document.querySelector<HTMLElement>(BasketChangedEmitter.AMOUNT_SELECTOR)?.dataset.minibasketamount;
        if (!raw) {
            return undefined;
        }

        const amount = Number(raw);
        return Number.isFinite(amount) ? amount : undefined;
    }
}
